import { render, staticRenderFns } from "./timeago.vue?vue&type=template&id=257e2855"
import script from "./timeago.vue?vue&type=script&lang=ts"
export * from "./timeago.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports